import { Component, OnInit, output } from '@angular/core';
import { Params } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';

@Component({
  selector: 'app-sign-in-ui',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatButtonModule, MatCheckboxModule, ReactiveFormsModule, NgIf],
  templateUrl: './sign-in-ui.component.html',
  styleUrl: './sign-in-ui.component.scss',
})
export class SignInUiComponent implements OnInit {
  protected submitClick = output<Params>();

  protected form!: FormGroup;

  // Password Hide
  hidePassword = true;

  constructor(
    private fb: FormBuilder,
    protected themeService: CustomizerSettingsService
  ) {}

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  submit({value, valid}: {value: Params; valid: boolean}) {
    const formData = {...value};
    this.submitClick.emit(formData);
  }
}
